import KetExamMarkView from './component';

export default KetExamMarkView;



// WEBPACK FOOTER //
// ./containers/Group/KetExam/MarkView/index.js